var Bash = "Bash";
var C = "C";
var Go = "Go";
var Java = "Java";
var JavaScript = "JavaScript";
var Kotlin = "Kotlin";
var Perl = "Perl";
var PHP = "PHP";
var PowerShell = "PowerShell";
var Python = "Python";
var Ruby = "Ruby";
var Rust = "Rust";
var SQL = "SQL";
var Swift = "Swift";
var TypeScript = "TypeScript";
var Analytics = "Phân tích";
var Blockchain = "Blockchain";
var Compliance = "Tuân thủ";
var Compute = "Điện toán";
var Containers = "Bộ chứa";
var Databases = "Cơ sở dữ liệu";
var Games = "Trò chơi";
var Migration = "Microsoft";
var Mobile = "Di động";
var Networking = "Kết nối mạng";
var Robotics = "Robot học";
var Satellite = "Vệ tinh";
var Security = "Bảo mật";
var Serverless = "Serverless";
var Storage = "Lưu trữ";
var WebApps = "WebApps";
var Alexa = "Alexa";
var Apache = "Apache";
var App2Container = "App2Container";
var AppFabric = "AppFabric";
var AppFlow = "AppFlow";
var AppSync = "AppSync";
var Artifact = "tạo tác";
var Athena = "Athena";
var Aurora = "Aurora";
var Backup = "Sao lưu";
var Batch = "Tập tin";
var Bedrock = "Bedrock";
var Braket = "Braket";
var Budgets = "Ngân sách";
var Chatbot = "Chatbot";
var Chime = "Chime";
var Cloud9 = "Cloud9";
var CloudEndure = "CloudEndure";
var CloudFormation = "CloudFormation";
var CloudFront = "CloudFront";
var CloudHSM = "CloudHSM";
var CloudSearch = "CloudSearch";
var CloudShell = "CloudShell";
var CloudTrail = "CloudTrail";
var CloudWatch = "CloudWatch";
var CodeArtifact = "CodeArtifact";
var CodeBuild = "CodeBuild";
var CodeCatalyst = "CodeCatalyst";
var CodeCommit = "CodeCommit";
var CodeDeploy = "CodeDeploy";
var CodeGuru = "CodeGuru";
var CodePipeline = "CodePipeline";
var CodeStar = "CodeStar";
var Cognito = "Cognito";
var Comprehend = "Comprehend";
var Config = "Config";
var Connect = "Connect";
var Copilot = "Copilot";
var Corretto = "Corretto";
var Dash = "Dấu gạch ngang";
var DataSync = "DataSync";
var DataZone = "DataSync";
var DeepComposer = "DeepComposer";
var DeepLens = "DeepLens";
var DeepRacer = "DeepRacer";
var Detective = "Ghi nhận lỗi";
var DocumentDB = "DocumentDB";
var DynamoDB = "DynamoDB";
var EMR = "EMR";
var EventBridge = "EventBridge";
var Fargate = "Fargate";
var FinSpace = "FinSpace";
var Forecast = "Forecast";
var FreeRTOS = "FreeRTOS";
var FSx = "FSx";
var GameKit = "GameKit";
var GameLift = "GameLift";
var GameSparks = "GameSparks";
var Glue = "Glue";
var GuardDuty = "GuardDuty";
var Health = "Trạng thái";
var HealthLake = "HealthLake";
var Inferentia = "Inferentia";
var Inspector = "Inspector";
var Kendra = "Kendra";
var Kinesis = "Kinesis";
var Lambda = "Lambda";
var Lex = "Lex";
var Lightsail = "Lightsail";
var Lookout = "Lookout";
var Lumberyard = "Lumberyard";
var Macie = "Macie";
var Monitron = "Monitron";
var Neptune = "Neptune";
var Neuron = "Neuron";
var One = "Một";
var OpenShift = "OpenShift";
var OpsWorks = "OpsWorks";
var Organizations = "Tổ chức";
var Outposts = "Outposts";
var Panorama = "Panorama";
var Personalize = "Personalize";
var Pinpoint = "Pinpoint";
var Polly = "Polly";
var PrivateLink = "PrivateLink";
var Prometheus = "Prometheus";
var Proton = "Proton";
var QuickSight = "Quicksight";
var Redshift = "Redshift";
var Rekognition = "Rekognition";
var RoboMaker = "RobotMaker";
var SageMaker = "SageMaker";
var Shield = "Shield";
var Snowball = "Snowball";
var Snowcone = "Snowcone";
var Snowmobile = "Snowmobile";
var Sumerian = "Sumerian";
var TensorFlow = "TensorFlow";
var Textract = "Textract";
var Thinkbox = "Thinkbox";
var Timestream = "Timestream";
var Titan = "Titan";
var Transcribe = "Transcribe";
var Translate = "Translate";
var VMware = "VMware";
var Wavelength = "Wavelength";
var Wickr = "Wickr";
var WorkDocs = "WorkDocs";
var WorkLink = "WorkLink";
var WorkMail = "WorkMail";
var WorkSpaces = "WorkSpaces";
var interests = {
	".NET": ".NET",
	Bash: Bash,
	C: C,
	"C#": "C",
	"C++": "C++",
	Go: Go,
	Java: Java,
	JavaScript: JavaScript,
	Kotlin: Kotlin,
	Perl: Perl,
	PHP: PHP,
	PowerShell: PowerShell,
	Python: Python,
	Ruby: Ruby,
	Rust: Rust,
	"SAP ABAP": "SAP ABAP",
	SQL: SQL,
	Swift: Swift,
	TypeScript: TypeScript,
	Analytics: Analytics,
	"Application Integration": "Tích hợp ứng dụng",
	"AR/VR": "AR/VR",
	"Architecture Strategy": "Chiến lược kiến trúc",
	"Artificial Intelligence": "Trí tuệ nhân tạo",
	Blockchain: Blockchain,
	"Business applications": "Ứng dụng dành cho doanh nghiệp",
	"Cloud Financial Management": "Quản lý tài chính trên đám mây",
	"Cloud Foundations": "Nền tảng đám mây",
	Compliance: Compliance,
	Compute: Compute,
	"Contact Center": "Trung tâm chăm sóc khách hàng",
	Containers: Containers,
	"Data Integration": "Tích hợp dữ liệu",
	Databases: Databases,
	"Developer Tools": "Công cụ cho nhà phát triển",
	"End-User Computing (EUC)": "điện toán dành cho người dùng cuối (EUC)",
	"Front-End Development": "Phát triển giao diện",
	Games: Games,
	"Generative AI": "AI tạo sinh",
	"High Performance Computing (HPC)": "Điện toán hiệu năng cao (HPC)",
	"Identity Management": "Quản lý định danh",
	"Machine Learning": "Máy học",
	"Machine Learning & AI": "Máy học và AI",
	"Management & Governance": "Quản lý và quản trị",
	"Media services": "Dịch vụ truyền thông",
	Migration: Migration,
	Mobile: Mobile,
	Networking: Networking,
	"Networking & Content Delivery": "Mạng & cung cấp nội dung",
	"Quantum Technologies": "Công nghệ lượng tử",
	Robotics: Robotics,
	Satellite: Satellite,
	Security: Security,
	"Security, Identity, & Compliance": "Bảo mật, Nhận dạng và Tuân thủ",
	Serverless: Serverless,
	Storage: Storage,
	WebApps: WebApps,
	"API Gateway": "Cổng API",
	Alexa: Alexa,
	Apache: Apache,
	"Apache Airflow": "Apache Airflow",
	"Apache Kafka": "Apache Kafka",
	"APP Config": "Cấu hình APP",
	"App Mesh": "App Mesh",
	"App Runner": "Trình chạy ứng dụng",
	"App Studio": "Studio ứng dụng",
	App2Container: App2Container,
	AppFabric: AppFabric,
	AppFlow: AppFlow,
	"Application Discovery Service": "Dịch vụ khám phá ứng dụng",
	"Application Migration Service": "Dịch vụ di chuyển ứng dụng",
	"AppStream 2.0": "AppStream 2.0",
	AppSync: AppSync,
	Artifact: Artifact,
	Athena: Athena,
	"Audit Manager": "Trình quản lý kiểm tra",
	Aurora: Aurora,
	"Auto Scaling": "tự động điều chỉnh quy mô",
	Backup: Backup,
	Batch: Batch,
	Bedrock: Bedrock,
	"Billing Conductor": "Trình hỗ trợ thanh toán",
	Braket: Braket,
	Budgets: Budgets,
	"Certificate Manager": "Trình quản lý chứng chỉ",
	Chatbot: Chatbot,
	Chime: Chime,
	"Clean Rooms": "Clean Rooms",
	"Cloud Control API": "API kiểm soát đám mây",
	"Cloud Development Kit (CDK)": "Bộ phát triển đám mây (CDK)",
	"Cloud Directory": "Thư mục đám mây",
	"Cloud Map": "Cloud Map",
	"Cloud WAN": "WAN đám mây",
	Cloud9: Cloud9,
	CloudEndure: CloudEndure,
	CloudFormation: CloudFormation,
	CloudFront: CloudFront,
	CloudHSM: CloudHSM,
	CloudSearch: CloudSearch,
	CloudShell: CloudShell,
	CloudTrail: CloudTrail,
	CloudWatch: CloudWatch,
	CodeArtifact: CodeArtifact,
	CodeBuild: CodeBuild,
	CodeCatalyst: CodeCatalyst,
	CodeCommit: CodeCommit,
	CodeDeploy: CodeDeploy,
	CodeGuru: CodeGuru,
	CodePipeline: CodePipeline,
	CodeStar: CodeStar,
	Cognito: Cognito,
	Comprehend: Comprehend,
	"Compute Optimizer": "Trình tối ưu hóa điện toán",
	Config: Config,
	Connect: Connect,
	"Control Tower": "Control Tower",
	Copilot: Copilot,
	Corretto: Corretto,
	"Cost Explorer": "Trình khám phá chi phí",
	Dash: Dash,
	"Data Exchange": "Trao đổi dữ liệu",
	"Data Pipeline": "Quy trình dữ liệu ",
	"Database Migration Service (DMS)": "Dịch vụ di chuyển cơ sở dữ liệu (DMS)",
	DataSync: DataSync,
	DataZone: DataZone,
	"Deadline Cloud": "Deadline Cloud",
	"Deep Learning": "HỌC SÂU",
	DeepComposer: DeepComposer,
	DeepLens: DeepLens,
	DeepRacer: DeepRacer,
	Detective: Detective,
	"Device Farm": "Device Farm",
	"DevOps Guru": "DevOps Guru",
	" Direct Connect": " Direct Connect",
	"Directory Service": "Dịch vụ thư mục",
	"Distro for OpenTelemetry": "Distro dành cho OpenTelemetry",
	DocumentDB: DocumentDB,
	DynamoDB: DynamoDB,
	"Elastic Beanstalk": "Elastic Beanstalk",
	"Elastic Block Storage (EBS)": "Lưu trữ khối linh hoạt (EBS)",
	"Elastic Cloud Compute (EC2)": "Elastic Cloud Compute (EC2)",
	"Elastic Container Registry (ECR)": "Sổ đăng ký bộ chứa linh hoạt (ECR)",
	"Elastic Container Service (ECS)": "Elastic Container Service (ECS)",
	"Elastic Disaster Recovery (DRS)": "Phục hồi sau thảm họa linh hoạt (DRS)",
	"Elastic File System (EFS)": "Hệ thống tệp linh hoạt (EFS)",
	"Elastic Inference": "Elastic Inference",
	"Elastic Kubernetes Service (EKS)": "Dịch vụ Kubernetes linh hoạt (EKS)",
	"Elastic Transcoder": "Bộ chuyển mã linh hoạt",
	"Elemental ": "Elemental ",
	EMR: EMR,
	EventBridge: EventBridge,
	Fargate: Fargate,
	"Fault Injection Simulator": "Trình mô phỏng tiêm lỗi",
	"File Cache": "Bộ nhớ đệm tập tin",
	FinSpace: FinSpace,
	"Firewall Manager": "Trình quản lý tường lửa",
	Forecast: Forecast,
	"Fraud Detector": "Trình phát hiện gian lận",
	FreeRTOS: FreeRTOS,
	FSx: FSx,
	GameKit: GameKit,
	GameLift: GameLift,
	GameSparks: GameSparks,
	"Global Accelerator": "Trình tăng tốc toàn cầu",
	Glue: Glue,
	"Ground Station": "Trạm mặt đất",
	GuardDuty: GuardDuty,
	Health: Health,
	HealthLake: HealthLake,
	"IAM Identity Center": "Trung tâm danh tính AWS IAM",
	"Identity and Access Management (IAM)": "Quản lý nhận dạng và truy cập (IAM)",
	Inferentia: Inferentia,
	Inspector: Inspector,
	"Interactive Video Service": "Dịch vụ video tương tác",
	"Internet of Things (IoT)": "Internet vạn vật (IoT)",
	Kendra: Kendra,
	"Key Management Service (KMS)": "Dịch vụ quản lý khóa",
	Kinesis: Kinesis,
	"Lake Formation": "Lake Formation",
	Lambda: Lambda,
	"Launch Wizard": "Trình hướng dẫn khởi chạy",
	Lex: Lex,
	"License Manager": "Trình quản lý giấy phép",
	Lightsail: Lightsail,
	"Local Zones": "Vùng địa phương",
	"Location Service": "Dịch vụ vị trí",
	Lookout: Lookout,
	Lumberyard: Lumberyard,
	Macie: Macie,
	"Mainframe Modernization": "Hiện đại hóa máy tính lớn",
	"Managed Blockchain": "Blockchain được quản lý",
	"Managed Grafana": "Grafana được quản lý",
	Monitron: Monitron,
	"MQ Message Broker": "MQ Message Broker",
	Neptune: Neptune,
	"Network Firewall": "Tường lửa mạng",
	Neuron: Neuron,
	"Nimble Studio": "Nimble Studio",
	One: One,
	"OpenSearch Service (OSS)": "Dịch vụ OpenSearch (OSS)",
	OpenShift: OpenShift,
	OpsWorks: OpsWorks,
	Organizations: Organizations,
	Outposts: Outposts,
	Panorama: Panorama,
	Personalize: Personalize,
	Pinpoint: Pinpoint,
	Polly: Polly,
	"Private 5G": "5G riêng",
	"Private Certificate Authority": "Nhà cung cấp chứng chỉ riêng",
	PrivateLink: PrivateLink,
	Prometheus: Prometheus,
	Proton: Proton,
	"Q ": "Q ",
	"Quantum Solutions Lab": "Phòng thực hành giải pháp lượng tử",
	QuickSight: QuickSight,
	"Relational Database Service (RDS)": "Relational Database Service (RDS)",
	Redshift: Redshift,
	Rekognition: Rekognition,
	"rePost Private": "rePost Private",
	"Resilience Hub": "Trung tâm khả năng phục hồi",
	"Resource Access Manager": "Resource Access Manager",
	RoboMaker: RoboMaker,
	"Route 53": "Route 53",
	SageMaker: SageMaker,
	"Secrets Manager": "Trình quản lý thông tin bí mật",
	"Security Hub": "Trung tâm bảo mật",
	"Security Lake": "Security Lake",
	"Server Migration Service (SMS)": "Dịch vụ di chuyển máy chủ (SMS)",
	"Serverless Application Repository": "Kho ứng dụng phi máy chủ",
	"Service Catalog": "Service Catalog",
	"Service Management Connector": "Bộ kết nối quản lý dịch vụ",
	Shield: Shield,
	"Simple Email Service (SES)": "Dịch vụ Email đơn giản (SES)",
	"Simple Notification Service (SNS)": "Dịch vụ thông báo đơn giản (SNS)",
	"Simple Queue Service (SQS)": "Dịch vụ xếp hàng đơn giản (SQS)",
	"Simple Storage Service (S3)": "Simple Storage Service (S3)",
	"Simspace Weaver": "SimSpace Weaver",
	"Single Sign-On (SSO)": "đăng nhập đơn (SSO)",
	"Snow Family": "Snow Family",
	Snowball: Snowball,
	Snowcone: Snowcone,
	Snowmobile: Snowmobile,
	"Step Functions": "Step Functions",
	"Storage Gateway": "Cổng lưu trữ",
	Sumerian: Sumerian,
	"Supply Chain": "Chuỗi cung ứng",
	"Systems Manager": "Trình quản lý hệ thống",
	"Telco Network Builder": "Trình dựng mạng viễn thông",
	TensorFlow: TensorFlow,
	Textract: Textract,
	Thinkbox: Thinkbox,
	Timestream: Timestream,
	Titan: Titan,
	Transcribe: Transcribe,
	Translate: Translate,
	"Trusted Advisor": "Trusted Advisor",
	"Verified Access": "Truy cập được xác minh",
	"Verified Permissions": "Quyền được xác minh",
	"Virtual Private Cloud (VPC)": "đám mây riêng ảo (VPC)",
	"Virtual Private Network (VPN)": "mạng riêng ảo (VPN)",
	VMware: VMware,
	Wavelength: Wavelength,
	"Web Application Firewall (WAF)": "Tường lửa ứng dụng web (WAF)",
	Wickr: Wickr,
	WorkDocs: WorkDocs,
	WorkLink: WorkLink,
	WorkMail: WorkMail,
	WorkSpaces: WorkSpaces,
	"X-Ray": "X-Ray"
};

export { Alexa, Analytics, Apache, App2Container, AppFabric, AppFlow, AppSync, Artifact, Athena, Aurora, Backup, Bash, Batch, Bedrock, Blockchain, Braket, Budgets, C, Chatbot, Chime, Cloud9, CloudEndure, CloudFormation, CloudFront, CloudHSM, CloudSearch, CloudShell, CloudTrail, CloudWatch, CodeArtifact, CodeBuild, CodeCatalyst, CodeCommit, CodeDeploy, CodeGuru, CodePipeline, CodeStar, Cognito, Compliance, Comprehend, Compute, Config, Connect, Containers, Copilot, Corretto, Dash, DataSync, DataZone, Databases, DeepComposer, DeepLens, DeepRacer, Detective, DocumentDB, DynamoDB, EMR, EventBridge, FSx, Fargate, FinSpace, Forecast, FreeRTOS, GameKit, GameLift, GameSparks, Games, Glue, Go, GuardDuty, Health, HealthLake, Inferentia, Inspector, Java, JavaScript, Kendra, Kinesis, Kotlin, Lambda, Lex, Lightsail, Lookout, Lumberyard, Macie, Migration, Mobile, Monitron, Neptune, Networking, Neuron, One, OpenShift, OpsWorks, Organizations, Outposts, PHP, Panorama, Perl, Personalize, Pinpoint, Polly, PowerShell, PrivateLink, Prometheus, Proton, Python, QuickSight, Redshift, Rekognition, RoboMaker, Robotics, Ruby, Rust, SQL, SageMaker, Satellite, Security, Serverless, Shield, Snowball, Snowcone, Snowmobile, Storage, Sumerian, Swift, TensorFlow, Textract, Thinkbox, Timestream, Titan, Transcribe, Translate, TypeScript, VMware, Wavelength, WebApps, Wickr, WorkDocs, WorkLink, WorkMail, WorkSpaces, interests as default };
